(function () {
  if (window.__cafFeaturedCollectionV2SortInitialized) return;
  window.__cafFeaturedCollectionV2SortInitialized = true;

  function destroyScopedSlider(section) {
    if (!window.jQuery) return;

    window.jQuery(section)
      .find('.featured-collection-v2__products .products-slider.flickity-enabled')
      .each(function () {
        window.jQuery(this).flickity('destroy');
        window.jQuery(this).removeClass('slider-initialized');
      });
  }

  function initScopedSlider(section) {
    if (!window.jQuery) return;

    window.jQuery(section)
      .find('.featured-collection-v2__products .products-slider')
      .each(function () {
        var $slider = window.jQuery(this);

        if ($slider.hasClass('flickity-enabled') || $slider.hasClass('slider-initialized')) return;

        var productsPerSlide = $slider.data('products-per-slide');
        var productsLimit = $slider.data('products-limit');
        var productsAvailable = $slider.data('products-available');
        var cellAlign = '';
        var draggable = false;

        if (window.Shopify && window.Shopify.loadFeatures && window.productMedia && window.productMedia.setupMedia) {
          window.Shopify.loadFeatures(
            [
              { name: 'shopify-xr', version: '1.0' },
              { name: 'model-viewer-ui', version: '1.0' },
            ],
            window.productMedia.setupMedia
          );
        }

        if (productsAvailable > productsPerSlide && productsLimit > productsPerSlide) {
          draggable = true;
        }

        if (window.PXUTheme && window.PXUTheme.media_queries.medium.matches) {
          cellAlign = 'center';
          draggable = true;
          $slider.parents('.even-num-slides').removeClass('even-num-slides');
        } else {
          cellAlign = 'left';
        }

        $slider
          .flickity({
            lazyLoad: 2,
            imagesLoaded: true,
            draggable: draggable,
            wrapAround: false,
            cellAlign: cellAlign,
            pageDots: false,
            contain: true,
            freeScroll: true,
          })
          .on('settle.flickity', function () {
            var flkty = $slider.data('flickity');
            if (!flkty) return;

            if (flkty.selectedIndex === 0) {
              $slider.find('.flickity-prev-next-button.previous').hide();
            }

            if (flkty.selectedIndex === flkty.cells.length - 1) {
              $slider.find('.flickity-prev-next-button.next').hide();
            }
          })
          .on('change.flickity', function () {
            var flkty = $slider.data('flickity');
            if (!flkty) return;

            if (flkty.selectedIndex === 0) {
              $slider.find('.flickity-prev-next-button.previous').hide();
            } else {
              $slider.find('.flickity-prev-next-button.previous').show();
            }

            if (flkty.selectedIndex === flkty.cells.length - 1) {
              $slider.find('.flickity-prev-next-button.next').hide();
            } else {
              $slider.find('.flickity-prev-next-button.next').show();
            }
          });

        $slider.addClass('slider-initialized');
      });
  }

  function initSectionFeatures(section) {
    destroyScopedSlider(section);
    initScopedSlider(section);

    if (window.productPage) {
      if (typeof window.productPage.init === 'function') {
        window.productPage.init();
      }

      if (typeof window.productPage.runOptionSelector === 'function' && window.jQuery) {
        window.productPage.runOptionSelector(window.jQuery(section));
      }
    }

    if (window.videoFeature && typeof window.videoFeature.init === 'function') {
      window.videoFeature.init();
    }
  }

  function buildRenderUrl(section) {
    var collectionUrl = section.getAttribute('data-collection-url');
    var productSort = section.getAttribute('data-product-sort');
    var sectionId = section.getAttribute('data-section-id');

    if (!collectionUrl || !productSort || !sectionId || productSort === 'collection-default') {
      return null;
    }

    var url = new URL(collectionUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('sort_by', productSort);
    url.searchParams.set('_caf_featured_collection_sort', '1');

    return url.toString();
  }

  function hydrateSection(section) {
    if (!section || section.dataset.featuredCollectionSortHydrated === '1') return;

    var renderUrl = buildRenderUrl(section);
    if (!renderUrl) return;

    section.dataset.featuredCollectionSortHydrated = '1';

    fetch(renderUrl, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to render featured collection v2');
        }

        return response.text();
      })
      .then(function (markup) {
        if (!markup || !markup.trim()) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(markup, 'text/html');
        var sectionId = section.getAttribute('data-section-id');
        var targetContent = section.querySelector('[data-featured-collection-v2-content]');
        var replacement = doc.getElementById('shopify-section-' + sectionId);
        var replacementContent = null;

        if (!replacement) {
          replacement = doc.querySelector('[data-featured-collection-v2-root]');
        }

        if (replacement) {
          replacementContent = replacement.querySelector('[data-featured-collection-v2-content]');
        }

        if (!targetContent || !replacementContent) {
          throw new Error('Invalid featured collection v2 markup');
        }

        targetContent.innerHTML = replacementContent.innerHTML;
        section.dataset.featuredCollectionSortHydrated = '1';
        initSectionFeatures(section);
      })
      .catch(function (error) {
        console.warn(error);
        delete section.dataset.featuredCollectionSortHydrated;
      });
  }

  function hydrateAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-featured-collection-v2-root]');

    sections.forEach(function (section) {
      hydrateSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hydrateAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!section) return;
    hydrateAll(section);
  });
})();
